(() => {
  'use strict';
  if (window.AvonticBuybox145) return;
  const put = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  const parse = node => { try { return JSON.parse(node?.textContent || 'null'); } catch { return null; } };
  const formatMoney = (cents, currency, locale) => new Intl.NumberFormat(locale || 'en', {style:'currency', currency}).format(cents / 100);
  // Invalid/incomplete typed quantities never show a plausible but incorrect subtotal.
  function priceState(input, variant, currency, locale) {
    const quantity = Number(input?.value);
    if (!input || !Number.isSafeInteger(quantity) || quantity < 1 || !input.checkValidity()) return null;
    if (!variant || !Number.isFinite(Number(variant.price))) return null;
    return {quantity, total:formatMoney(Number(variant.price) * quantity, currency, locale), unit:formatMoney(Number(variant.price), currency, locale)};
  }
  function render() {
    const root = document.querySelector('#avontic-primary-product');
    if (!root) return;
    const buy = root.querySelector('[data-block-id="buy_buttons"]');
    const productForm = buy?.querySelector('product-form');
    const form = productForm?.querySelector('form');
    const quantity = root.querySelector('[data-block-id="quantity_selector"]');
    const input = quantity?.querySelector('input[name="quantity"]');
    if (!buy || !form || !quantity || !input) return;
    root.dataset.avBuybox = '145';
    quantity.classList.add('av-buybox-quantity-row');
    // Preserve the complete theme block so native variant re-rendering can refresh its rules.
    if (productForm.previousElementSibling !== quantity) productForm.before(quantity);
    const offers = buy.querySelector('[data-av-purchase-offers]');
    if (offers && productForm.nextElementSibling !== offers) productForm.after(offers);
    const subtotal = quantity.querySelector('[data-av-buybox-subtotal]');
    if (!subtotal) return;
    const variantNode = root.querySelector('variant-picker script[data-variant]');
    const variant = variantNode ? parse(variantNode) : {id:subtotal.dataset.variantId, price:Number(subtotal.dataset.unitPrice)};
    // The variant input is named "id", which masks HTMLFormElement.id in browsers.
    const formId = form.getAttribute('id');
    const inputId = input.id || `${formId}-buybox-quantity`;
    input.id = inputId;
    const label = quantity.querySelector('.av-buybox-quantity-label');
    if (label) { label.id = `${inputId}-label`; input.setAttribute('aria-labelledby', label.id); }
    const currentId = form.querySelector('input[name="id"]')?.value;
    const synchronized = variant && String(variant.id) === String(currentId);
    let price = null;
    try { price = synchronized ? priceState(input, variant, subtotal.dataset.currency, document.documentElement.lang) : null; } catch { /* Keep native purchasing intact if currency formatting is unavailable. */ }
    subtotal.hidden = !variant;
    put(subtotal.querySelector('[data-av-buybox-amount]'), price?.total || '—');
    put(subtotal.querySelector('[data-av-buybox-unit]'), price ? `${price.unit} each` : synchronized ? 'Check quantity' : 'Updating selection…');
    quantity.querySelectorAll('.quantity-selector__button').forEach(button => button.removeAttribute('tabindex'));
    // Mirror quantity in the existing sticky price without touching purchase availability or event handlers.
    document.querySelectorAll('product-sticky-bar').forEach(sticky => {
      if (sticky.getAttribute('form') !== formId) return;
      sticky.dataset.avBuybox = '145';
      const priceNode = sticky.querySelector('.av-pdp-sticky__price');
      if (price && priceNode) {
        put(priceNode, price.quantity > 1 ? `${price.total} · ${price.quantity} items` : price.total);
        priceNode.setAttribute('aria-label', `Item subtotal ${price.total} for ${price.quantity} ${price.quantity === 1 ? 'item' : 'items'}`);
      }
    });
  }
  let queued = false;
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; render(); }); } };
  ['input','change'].forEach(name => document.addEventListener(name, event => { if (event.target.matches?.('#avontic-primary-product input[name="quantity"]')) schedule(); }));
  ['variant:change','product:rerender','shopify:section:load','avontic:purchase-fit-ready'].forEach(name => document.addEventListener(name, schedule));
  window.addEventListener('pageshow', schedule);
  function start() {
    render();
    const root = document.querySelector('#avontic-primary-product');
    if (root) new MutationObserver(records => {
      // Ignore our text updates and unrelated product content. No polling or network requests.
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('variant-picker,product-form,[data-block-id="quantity_selector"],[data-av-buybox-subtotal]') || node.querySelector('variant-picker,product-form,[data-block-id="quantity_selector"],[data-av-buybox-subtotal]'))))) schedule();
    }).observe(root, {childList:true, subtree:true});
  }
  window.AvonticBuybox145 = Object.freeze({version:'2026-09-30.1'});
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, {once:true}) : start();
})();
